import {priority} from '@priority-software/priority-proto-api/lib';

export enum ColumnType {
    Text = 'Text',
    Bool = 'Bool',
    Number = 'Number',
    Date = 'Date',
    Time = 'Time',
    Duration = 'Duration'
}

export const ColumnTypeToCodeMap = {
    [priority.netitems.form.ColumnType.Boolean]: 'Bool',
    [priority.netitems.form.ColumnType.Int]: 'Int',
    [priority.netitems.form.ColumnType.Real]: 'Real',
    [priority.netitems.form.ColumnType.Date8]: 'Date8',
    [priority.netitems.form.ColumnType.Date10]: 'Date10',
    [priority.netitems.form.ColumnType.Date14]: 'Date14',
    [priority.netitems.form.ColumnType.Time5]: 'Time5',
    [priority.netitems.form.ColumnType.Time6]: 'Time6',
    [priority.netitems.form.ColumnType.Rstr]: 'Rstr',
    [priority.netitems.form.ColumnType.Str]: 'Str',
    [priority.netitems.form.ColumnType.Char]: 'Char',
    [priority.netitems.form.ColumnType.Day]: 'Day'
};

export function getBaseColumnType(columnType: priority.netitems.form.ColumnType): ColumnType {
    switch (columnType) {
        case priority.netitems.form.ColumnType.Rstr:
        case priority.netitems.form.ColumnType.Char:
        case priority.netitems.form.ColumnType.Operator:
        case priority.netitems.form.ColumnType.Str:
            return ColumnType.Text;
        case priority.netitems.form.ColumnType.Boolean:
            return ColumnType.Bool;
        case priority.netitems.form.ColumnType.Date8:
        case priority.netitems.form.ColumnType.Date10:
        case priority.netitems.form.ColumnType.Date14:
            return ColumnType.Date;
        case priority.netitems.form.ColumnType.Time5:
            return ColumnType.Time;
        case priority.netitems.form.ColumnType.Time6:
            return ColumnType.Duration;
        case priority.netitems.form.ColumnType.Int:
        case priority.netitems.form.ColumnType.Real:
        case priority.netitems.form.ColumnType.Unsigned:
            return ColumnType.Number;
        default:
            return ColumnType.Text;
    }
}
